import React, { useEffect, useState } from 'react'
import { GashaponV2 as GashaponComponent } from "../../../Components/Player/GashaponV2"
import { Flex } from 'antd'
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useLocation } from 'react-router-dom';

//IMAGENES
import FONDOGASHA from '../../../Assets/fondogasha.jpg'
import MAQUINAGASHA from '../../../Assets/gasha.png'
import MANILLAGASHA from '../../../Assets/manilla.png'
import ENGRANAJEGASHA from '../../../Assets/engranaje.png'
import GASHAPONBALL from '../../../Assets/gashaponball.png'
import GASHAPONBALLOPEN from '../../../Assets/gashaopen.png'
import CAPSULASBACK from '../../../Assets/pelotasfondo.png'
import CAPSULASFRONT from '../../../Assets/pelotasfrente.png'

export const GashaponV2 = () => {
  const navigate = useNavigate();
  const isDesktopOrLaptop =  useMediaQuery({ query: '(min-device-width: 1224px)' });
  const location = useLocation();
  const gacha_id = location.state?.gacha_id;
  const coin_id = location.state?.coin_id;
  const pokemons = location.state?.pokemons;
  const background = location.state?.background;


  const IMGS = [
    FONDOGASHA,
    MAQUINAGASHA,
    MANILLAGASHA,
    ENGRANAJEGASHA,
    GASHAPONBALL,
    GASHAPONBALLOPEN,
    CAPSULASBACK,
    CAPSULASFRONT,
    background
  ]

  const [imageCache, setImageCache] = useState({});
  // Precargar imágenes
  useEffect(() => {
      const cache = {};
      IMGS.forEach((item, index) => {
          const url = item;
          const img = new Image();
          img.src = url;
          cache[index] = img.src;
      });
      setImageCache(cache);
  }, []);
  return (
    <Flex justify='center' align='center'>
      {
        isDesktopOrLaptop ? navigate("/404") : <GashaponComponent gacha_id={gacha_id} coin_id={coin_id} pokemons={pokemons} imagenesCache={imageCache} />
      }
    </Flex>
  )
}
